export const formatStreetWithUnit = (
  streetNumber: string | undefined,
  streetName: string | undefined,
  unitNumber: string | undefined
): string => {
  const street = [streetNumber, streetName].filter(Boolean).join(' ');
  if (!unitNumber) return street;
  return `${unitNumber}-${street}`;
};
